export const required = value => (value ? undefined : 'Required')

export const minPasswordLength = value => (value && value.length < 8) ? 'Password must greater than 8 characters' : undefined

export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined)

export const matches = (value, values) => (value === values.password) ? undefined: 'Passwords do not match';